import { render, staticRenderFns } from "./TweetEmbed.vue?vue&type=template&id=481d4038&"
import script from "./TweetEmbed.vue?vue&type=script&lang=js&"
export * from "./TweetEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports